// supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL; // Remplacez par votre URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/*const supabase = createClient(supabaseUrl, supabaseKey, {
  headers: {
    apiKey: anonKey,
    Authorisation: `Bearer ${jwt}`
  }
});*/
